import { useContext } from "react";
import { ToolsContext } from "../../ToolsContext";
import { RoutePicker } from "./RoutePicker";
import { RoutePropertyEditor } from "./RoutePropertyEditor";

export function Routes() {
    const tool = useContext(ToolsContext);
    let panelHeight = '82vh';

    return (
        <>
            <div style={{ height: panelHeight }}>
                {
                    (tool.propertyEditor == null) ? 
                        <RoutePicker className="flex align-content-center" />
                    : 
                        <RoutePropertyEditor key={tool.propertyEditor.edit.route_id} GRoute={tool.propertyEditor.edit}></RoutePropertyEditor>
                 }
            </div>
        </>
    );
}